import { Engine } from 'json-rules-engine';
import { init as initFacts } from './facts-impl';
import { md5 } from 'js-md5';

const CondtionCache =  window.__FEGO_CONDITION_CACHE__ || {};
window.__FEGO_CONDITION_CACHE__ = CondtionCache;

export const excuteRule = async (fegoRule, context) => {
    const { items = [] } = fegoRule?.[0] || {};
    const engine = new Engine();
    const facts = initFacts();
    //添加一个全局的fact，用于存储一些全局的变量，比如当前变量，当前上下文，当前配置等
    engine.addFact('__FEGO_RUNTIME__', {
        context,
        config: fegoRule
    });

    items.forEach((item) => {
        //有些条件需要根据前置条件来判断是否执行所以需要将前置条件传递给每一个条件
        //所有的条件都是先any，再all的规则类型 ( a=1 and b=2 ) or ( c=3 and d=4 )
        item?.conditions?.any?.forEach?.((condition) => {
            const preConditions = [];
            condition.all.forEach((node) => {
                node.params.preConditions = [...preConditions];
                preConditions.push(node);
            });
        });
        engine.addRule(item);
    });

    const res = await engine.run(facts);

    //生成返回格式，格式以 id: {result, params} 的形式返回
    const results = {};
    res.results.forEach((item) => {
        results[item.event.params.id] = {
            eventName: item.name,
            result: item.result,
            params: item.event.params
        };
    });

    res.failureResults.forEach((item) => {
        results[item.event.params.id] = {
            eventName: item.name,
            result: item.result,
            params: item.event.params
        };
    });

    console.log('[fego-condition][runRule]results', results, res);
    //添加调试入口
    if (location?.href?.indexOf?.('_fego_debug_') > -1) {
        window.__FEGO_CONDITION_RESULT__ = window.__FEGO_CONDITION_RESULT__ || [];
        window.__FEGO_CONDITION_RESULT__.push({
            results,
            res,
            time: +new Date()
        });
    }
    return results;
};

export const runRule = async (fegoRule, context, options = { enableCache: true }) =>{

    //如果不开启缓存，那么直接执行规则
    if (options.enableCache === false){
        return await excuteRule(fegoRule, context);
    }

    //如果开启了缓存，那么将规则进行md5加密，然后从缓存中获取
    //缓存的key是由规则和变量组成的
    const cacheObject = {
        fegoRule,
        fegoVariable : context?.FEGORender?.store?.variable?.data || {},
    };
    const cacheKey = md5(JSON.stringify(cacheObject));

    if (!CondtionCache[cacheKey]) {
        console.log('[fego-condition][runRule]no cache', cacheKey);
        CondtionCache[cacheKey] = excuteRule(fegoRule, context);
    } else {
        console.log('[fego-condition][runRule]hit cache', cacheKey);
    }

    return await CondtionCache[cacheKey];
};
